
const getNowTimestamp = () => Date.now();

export default getNowTimestamp;
